<template>

    <m-edit1/>

    <m-section-503 v-bind='{...{"mainColor":"F9FAFB#","fadeColor":"var(--primary)"},...{}}' :style='""' class="" >
                <template #default>   <m-login-1 v-bind='{...{"image":"https:\/\/api.medicalmobile.ir\/storage\/assets\/test_account_512px.png","showPanels":false,"imageParentClass":"  d-none d-lg-block","defaultPanel":0},...{}}' :style='""' class="my-5 col-12 p-0 login-component" >
                <template #classic-login-p-1-bottom>   </template>
                
                <template #classic-login-p-1-top>   </template>
                
                <template #two-step-login-p-1-bottom>   </template>
                
                <template #two-step-login-p-1-top>   </template>
                </m-login-1></template>
                </m-section-503>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSection503 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section503'; import mLogin1 from '@moeinmdn/miw-alpha-components/src/package/Authentication/Login/Login1';

export default {
    name: 'HomeView',
    components: {mEdit1, mSection503,mLogin1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
